<div class="d-flex">
	<h2>
		{{ step.label["iterlex.currentLanguage" | translate] }}
	</h2>
	<button type="button" itButton="link" (click)="editStepModal.toggle()">
		<it-icon
			name="pencil"
			[title]="'it.general.edit' | translate"
		></it-icon>
	</button>
	<button
		class="me-auto"
		type="button"
		itButton="link"
		(click)="deleteStepModal.toggle()"
	>
		<it-icon
			name="delete"
			color="danger"
			[title]="'iterlex.delete-step' | translate"
		></it-icon>
	</button>
	<button
		type="button"
		itButton="primary"
		(click)="createDocumentModal.toggle()"
		class="ms-3 align-self-end"
	>
		{{ "iterlex.create-document" | translate }}
	</button>
	@if (isSharePhase && dossier.state === "InProgress") {
		<button
			class="ms-3 align-self-end"
			type="button"
			itButton="secondary"
			[disabled]="progressSendToStagingArea"
			[progress]="progressSendToStagingArea"
			(click)="sendToStagingAreaModal.toggle()"
		>
			{{ "iterlex.send-to-staging-area" | translate }}
		</button>
	}
	@if (
		(step.id === "bozzaDelibera" || step.id === "deliberaInBozza") &&
		dossier.state === "InProgress"
	) {
		<button
			class="ms-3 align-self-end"
			type="button"
			itButton="secondary"
			(click)="getFiles(); sendToBedeModal.toggle()"
		>
			{{ "iterlex.send-to-bede" | translate }}
		</button>
	}
</div>
<div class="row mt-5">
	@for (document of documents; track document.workUri) {
		<div class="col-lg-6 col-xs-12">
			<div class="card-wrapper card-space">
				<app-document
					class="w-100"
					[dossier]="dossier"
					[currentPhase]="phase"
					[currentStep]="step"
					[authority]="authority"
					[body]="body"
					[document]="document"
					[documentTypes]="documentTypes"
					[progressDeleteDocument]="
						progressDeleteDocumentUri === document.workUri
					"
					(setCurrentPhaseEvent)="setCurrentPhaseEvent.emit($event)"
					(deleteDocument)="
						currentDocument = $event; deleteDocumentModal.toggle()
					"
					(refreshDocuments)="this.getDocuments()"
				></app-document>
			</div>
		</div>
	}
</div>

<it-modal #createDocumentModal>
	<ng-container modalTitle>{{
		"iterlex.create-document" | translate
	}}</ng-container>
	<form
		#createDocumentForm="ngForm"
		(ngSubmit)="onCreateDocumentSubmit(createDocumentForm)"
	>
		<it-select
			name="documentSubtype"
			[label]="'iterlex.document-subtype' | translate"
			ngModel
			required
		>
			<option selected value="">
				{{ "iterlex.select-document-subtype" | translate }}
			</option>
			@for (
				documentSubtype of documentSubtypes;
				track documentSubtype.id
			) {
				<option
					[value]="
						documentSubtype.documentType + '/' + documentSubtype.id
					"
				>
					{{
						documentSubtype.label[
							"iterlex.currentLanguage" | translate
						]
					}}
				</option>
			}
		</it-select>
		<it-input
			type="text"
			name="title"
			[ngModel]="
				['bill/dlp', 'act/dec'].includes(
					createDocumentForm.value.documentSubtype
				)
					? dossier.title
					: undefined
			"
			required
			[label]="'iterlex.title' | translate"
		></it-input>
		<it-input
			type="text"
			name="number"
			[ngModel]="
				['bill/dlp', 'act/dec'].includes(
					createDocumentForm.value.documentSubtype
				)
					? dossier.number
					: undefined
			"
			required
			[label]="'iterlex.number' | translate"
		></it-input>
		<it-select
			name="language"
			[label]="'iterlex.language' | translate"
			[ngModel]="
				['bill/dlp', 'act/dec'].includes(
					createDocumentForm.value.documentSubtype
				)
					? 'mul'
					: ''
			"
			required
		>
			<option selected value="">
				{{ "it.utils.select-language" | translate }}
			</option>
			@for (language of languages; track language) {
				<option [value]="language">
					{{ "iterlex." + language | translate }}
				</option>
			}
		</it-select>
		<it-input
			type="date"
			name="date"
			ngModel
			required
			[label]="'iterlex.date' | translate"
		></it-input>
		<it-input
			type="time"
			name="time"
			ngModel
			required
			[label]="'iterlex.time' | translate"
			ngModel="00:00"
		></it-input>
		<div class="form-group">
			<input
				type="file"
				name="file"
				ngModel
				(change)="setCurrentFile($event.target.files)"
			/>
		</div>
		<button
			itButton="primary"
			type="submit"
			[disabled]="!createDocumentForm.valid"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.create-document" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #editStepModal>
	<ng-container modalTitle>{{ "it.general.edit" | translate }}</ng-container>
	<form #editStepForm="ngForm" (ngSubmit)="onEditStepSubmit(editStepForm)">
		<it-input
			type="text"
			name="descriptionITA"
			ngModel
			required
			[label]="('iterlex.title' | translate) + ' (ITA)'"
			[ngModel]="step.label['it']"
		></it-input>
		<it-input
			type="text"
			name="descriptionDEU"
			ngModel
			required
			[label]="('iterlex.title' | translate) + ' (DEU)'"
			[ngModel]="step.label['de']"
		></it-input>
		<button
			itButton="primary"
			type="submit"
			[disabled]="!editStepForm.valid"
			data-bs-dismiss="modal"
		>
			{{ "it.general.save" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #deleteStepModal closeButton="false" popconfirm="true">
	<ng-container modalTitle>{{
		"iterlex.delete-step-confirm" | translate
	}}</ng-container>
	<p>
		{{
			"iterlex.delete-step-confirm-description"
				| translate
					: {
							name: step.label[
								"iterlex.currentLanguage" | translate
							],
					  }
		}}
	</p>
	<ng-container footer>
		<button
			itButton="danger"
			type="button"
			data-bs-dismiss="modal"
			(click)="deleteStep()"
		>
			{{ "it.core.remove" | translate }}
		</button>
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
<it-modal #deleteDocumentModal closeButton="false" popconfirm="true">
	<ng-container modalTitle>{{
		"iterlex.delete-document-confirm" | translate
	}}</ng-container>
	@if (currentDocument) {
		<p>
			{{
				"iterlex.delete-document-confirm-description"
					| translate: { name: currentDocument.title }
			}}
		</p>
	}
	<ng-container footer>
		@if (currentDocument) {
			<button
				itButton="danger"
				type="button"
				data-bs-dismiss="modal"
				(click)="deleteDocument(currentDocument.workUri)"
			>
				{{ "it.core.remove" | translate }}
			</button>
		}
		<button
			itButton="outline-secondary"
			type="button"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.cancel" | translate }}
		</button>
	</ng-container>
</it-modal>
<it-modal #sendToStagingAreaModal>
	<ng-container modalTitle>{{
		"iterlex.send-to-staging-area" | translate
	}}</ng-container>
	<form
		#sendToStagingAreaForm="ngForm"
		(ngSubmit)="onSendToStagingAreaSubmit(sendToStagingAreaForm)"
	>
		<it-select
			name="authority"
			ngModel
			[label]="'iterlex.authority' | translate"
			required
		>
			<option selected value="">
				{{ "iterlex.select-authority" | translate }}
			</option>
			@for (authority of authorities; track authority.id) {
				<option [value]="authority.id">
					{{ authority.label["iterlex.currentLanguage" | translate] }}
				</option>
			}
		</it-select>
		<button
			itButton="primary"
			type="submit"
			[disabled]="!sendToStagingAreaForm.valid"
			data-bs-dismiss="modal"
		>
			{{ "it.general.send" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
<it-modal #sendToBedeModal>
	<ng-container modalTitle>{{
		"iterlex.send-to-bede" | translate
	}}</ng-container>
	<form
		#sendToBedeForm="ngForm"
		(ngSubmit)="onSendToBedeSubmit(sendToBedeForm)"
	>
		@for (file of files; track file.manifestationUri) {
			<div class="d-flex align-items-center mb-2">
				<button
					type="button"
					itButton="outline-primary"
					size="xs"
					class="me-2"
					[disabled]="$last"
					(click)="orderFiles($index, 1)"
				>
					<it-icon name="arrow-down"></it-icon>
				</button>
				<button
					type="button"
					itButton="outline-primary"
					size="xs"
					[disabled]="$first"
					(click)="orderFiles($index, -1)"
				>
					<it-icon name="arrow-up"></it-icon>
				</button>
				<it-checkbox
					[checked]="selectedFiles.has(file.manifestationUri)"
					[label]="file.title"
					(click)="
						selectedFiles.has(file.manifestationUri)
							? selectedFiles.delete(file.manifestationUri)
							: selectedFiles.add(file.manifestationUri)
					"
				></it-checkbox>
			</div>
		}
		<button
			itButton="primary"
			type="submit"
			[disabled]="!sendToBedeForm.valid || selectedFiles.size === 0"
			data-bs-dismiss="modal"
		>
			{{ "iterlex.send-to-bede" | translate }}
		</button>
	</form>
	<ng-container footer><span></span></ng-container>
</it-modal>
